export default __webpack_public_path__ + "static/media/checkmark-warning.b7b46de7.svg";